import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../config/axios';
import '../styles/Login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const { data } = await axios.post('/auth/forgot-password', { email: email.trim() });
      setMessage(data.message || 'Check your email for reset instructions.');
    } catch (err) {
      const msg = err.response?.data?.error || 'Request failed';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Forgot password</h2>
        <p style={{ color: '#666', marginBottom: '1rem', fontSize: '0.95rem' }}>
          Enter your email. If you have an email/password account, we will send a reset link (valid 1 hour).
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {message && (
            <div className="error-message" style={{ background: '#e8f5e9', color: '#1b5e20', border: '1px solid #a5d6a7' }}>
              {message}
            </div>
          )}
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <p className="register-link">
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
